import classNames from "classnames";
import React from "react";

import {
    IReviewQueryFacets,
    ISearchFacetOption,
    ISearchFacetSubOption,
} from "../../../models/reviews.interfaces";
import { parseFacetValues } from "../../../utils/reviews";
import { useAppSelector, useDispatchers } from "../../reducers";
import { defaultState } from "../defaults";
import { Dispatchers } from "../dispatchers";

import styles from "./FilterOption.module.scss";

interface IProps {
    facetType: IReviewQueryFacets;
    option: ISearchFacetOption | ISearchFacetSubOption;
    showCount: boolean;
}

export const FilterOption = (props: IProps) => {
    const dispatchers = useDispatchers(Dispatchers);

    const isChecked = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        const values = parseFacetValues(
            reviewsState.ui.facetValues[props.facetType],
        );
        return values.includes(`${props.option.option_id}`);
    });

    const optionName = `${props.option.name}`.trim();
    const inputID =
        `${props.facetType}-${props.option.option_id}`.toLowerCase();

    const checkboxClasses = classNames({
        [styles.checkbox]: true,
        [styles.checkboxVariant]: true,
    });

    const variantClasses = classNames({
        [styles.filterTitle]: true,
        [styles.filterTitleVariant]: true,
    });
    return (
        <li className={styles.listItem}>
            <input
                id={inputID}
                type="checkbox"
                value={props.option.option_id}
                checked={isChecked}
                className={checkboxClasses}
                onChange={(e) => {
                    dispatchers.updateFilterOptionValue(
                        props.facetType,
                        props.option.option_id,
                        e.currentTarget.checked,
                    );
                }}
            />
            <label className={variantClasses} htmlFor={inputID}>
                <span dangerouslySetInnerHTML={{ __html: optionName }} />
                {props.showCount && (
                    <>
                        &nbsp;
                        <span>({props.option.quantity})</span>
                    </>
                )}
            </label>
        </li>
    );
};
